import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/about-us/page.tsx");
